/**
 * CooperProfile.js - Page profil COOPER'S
 * Utilise le composant ProfilePageModern unifié
 */
import React from 'react';
import ProfilePageModern from './ProfilePageModern';

export default function CooperProfile() {
  return <ProfilePageModern userType="cooper" />;
}
